import { useApi } from "./useApi";
import { billingService } from "../services/billing";
import { PortalResponse } from "../types/billing.types";

/**
 * Força o Stripe Customer Portal a abrir em português (Brasil),
 * independente do idioma configurado no navegador/conta Stripe do médico.
 */
const withPtBrLocale = (url: string): string => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set("locale", "pt-BR");
    return parsed.toString();
  } catch {
    return url;
  }
};

/**
 * POST /billing/portal + redirect. Único ponto de "gerenciar assinatura"
 * (Stripe Customer Portal) — reaproveitado por qualquer CTA que precise
 * mandar o médico pra lá (banner de aviso, modal de upgrade, tela de Conta & Plano).
 */
export const useBillingPortal = () => {
  const portalApi = useApi<PortalResponse>();

  const goToPortal = async () => {
    const result = await portalApi.request(() => billingService.postPortal(portalApi.apiFetch));
    if (result?.url) window.location.href = withPtBrLocale(result.url);
  };

  return { goToPortal, loading: portalApi.loading };
};
